import type { YaleAssureFeedbackFrame } from "./YaleAssureLock2"

export const HERO_CYCLE_MS = 24_000
const GUEST_PIN = "482619"

export type HeroMotion = {
  nestMode: "cool" | "heat"
  nestCoolingTarget: 68 | 74
  pressedKey: string | null
  feedbackFrame: YaleAssureFeedbackFrame | null
  accepted: boolean
  unlocked: boolean
  sensorActive: boolean
  cameraActive: boolean
}

/** A repeating marketing sequence; room temperature stays fixed at 72°F. */
export function getHeroMotion(elapsedMs: number): HeroMotion {
  const time = elapsedMs % HERO_CYCLE_MS
  const entryTime = time % 12_000
  const typingTime = entryTime - 1000
  const digitIndex = Math.floor(typingTime / 420)
  const enteringDigit = digitIndex >= 0 && digitIndex < GUEST_PIN.length && typingTime % 420 < 260
  const accepted = entryTime >= 4050 && entryTime < 6500

  return {
    nestMode: time < 16_000 ? "cool" : "heat",
    // Raising the cooling target lets the display return to its idle black face.
    nestCoolingTarget: time < 12_000 ? 68 : 74,
    pressedKey: enteringDigit ? GUEST_PIN.charAt(digitIndex) : entryTime >= 3700 && entryTime < 4050 ? "check" : null,
    // The manual confirms PIN → check. The row sweep is an illustrative acceptance cue.
    feedbackFrame: accepted ? Math.min(7, Math.floor((entryTime - 4050) / 180)) as YaleAssureFeedbackFrame : null,
    accepted,
    unlocked: entryTime >= 4050 && entryTime < 10_000,
    sensorActive: entryTime >= 6000 && entryTime < 10_500,
    cameraActive: entryTime >= 8000 && entryTime < 11_000,
  }
}

/** Only redraw when a visible state changes, rather than on every clock tick. */
export function sameHeroMotion(a: HeroMotion, b: HeroMotion) {
  return a.nestMode === b.nestMode
    && a.nestCoolingTarget === b.nestCoolingTarget
    && a.pressedKey === b.pressedKey
    && a.feedbackFrame === b.feedbackFrame
    && a.accepted === b.accepted
    && a.unlocked === b.unlocked
    && a.sensorActive === b.sensorActive
    && a.cameraActive === b.cameraActive
}
